// extracted by mini-css-extract-plugin
export default {"category_main_container":"CategoryPage_category_main_container__Y1KVl"};